import { render, staticRenderFns } from "./OverviewPanels.vue?vue&type=template&id=b01fe7d6&scoped=true"
import script from "./OverviewPanels.vue?vue&type=script&lang=js"
export * from "./OverviewPanels.vue?vue&type=script&lang=js"
import style0 from "./OverviewPanels.vue?vue&type=style&index=0&id=b01fe7d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01fe7d6",
  null
  
)

export default component.exports